import img1 from './assets/1.jpg'
import img2 from './assets/2.jpg'
import img3 from './assets/3.jpg'
import img4 from './assets/kover.png'

export default [
  {
    title: 'Redesign of e-commerce platform',
    tag: 'UI/UX',
    likes: 59,
    views: 778,
    link:
      'https://www.behance.net/gallery/50707677/Redesign-of-e-commerce-platform',
    img: img1
  },
  {
    title: 'New design for Kover.ru',
    tag: 'Web Design',
    likes: 17,
    views: 564,
    link: 'https://www.behance.net/gallery/22020095/E-commerce-website-design',
    img: img4
  },
  {
    title: 'A rug shop redesign',
    tag: 'Web Design',
    likes: 20,
    views: 224,
    link: 'https://www.behance.net/gallery/50804427/A-rug-shop-redesign',
    img: img2
  },

  {
    title: 'Watch shop redesign',
    tag: 'Interaction Design',
    likes: 228,
    views: 3557,
    link: 'https://www.behance.net/gallery/29160817/Watch-shop-redesign',
    img: img3
  }
]



// WEBPACK FOOTER //
// ./src/components/slides/LastProjects/data.js